import React from 'react';

const About: React.FC = () => {
  return (
    <div style={{padding: '24px'}}>
      <h1>About Us</h1>
      <img src="/images/about.svg" alt="About" style={{maxWidth: '100%', height: 'auto'}} />
      {/* <p style={{maxWidth: 800}}>Svec is a team of designers and engineers focused on delivering high-quality web experiences.</p> */}
    </div>
  );
};

export default About;
